export const assetPaths = {
    iconSprites: "/assets/icon_sprite.svg",
    logoLight: "/assets/logo_light.svg",
    logoDark: "/assets/logo_dark.svg",
    coverPlaceholderDark: "/assets/placeholder_dark.svg",
    coverPlaceholderLight: "/assets/placeholder_light.svg",
    appStore: "/assets/app-store.svg",
    googlePlay: "/assets/google-play.svg"
};
